module.exports = __webpack_public_path__ + "static/media/envelope.19f99bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/envelope.svg
// module id = 930
// module chunks = 7